import { render, staticRenderFns } from "./DrsTariff.vue?vue&type=template&id=4587ca0f"
import script from "./DrsTariff.vue?vue&type=script&lang=js"
export * from "./DrsTariff.vue?vue&type=script&lang=js"
import style0 from "./DrsTariff.vue?vue&type=style&index=0&id=4587ca0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports